import React from 'react';
import TweetComposerContent from './TweetComposerContent';
export default function ReplyTweetComposer(param) {
    var user = param.user, referenceTweet = param.referenceTweet, onSubmitAction = param.onSubmitAction, store = param.store, externalSetImages = param.externalSetImages;
    return /*#__PURE__*/ React.createElement(TweetComposerContent, {
        showProfileImage: false,
        user: user,
        mode: "reply",
        referenceTweet: referenceTweet,
        onSubmitAction: onSubmitAction,
        store: store,
        externalSetImages: externalSetImages
    });
}
